export const getAssetMasterList = state => {
    return state.list
}

export const getAssetMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/assetMaster/getters.js